import makeStyles from "@mui/styles/makeStyles";

export const useMenuItemStyles = makeStyles((theme) => ({
  root: {
    marginTop: 8,
    color: theme.palette.grey[700],
    fontWeight: 700,
    padding: 0,
    fontSize: "10px !important",
    opacity: "1 !important",
    "&:first-child": {
      marginTop: 0,
    },
  },
}));
